<template>
  <div
    class="step-wrapper"
    :class="{ 'step-wrapper--space-between': spaceBetween }"
  >
    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    spaceBetween: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .step-wrapper {
    @include full-size;

    @include media-up(md) {
      @include center;
      min-height: 100vh;
      height: auto;
      padding: 40px 0;
    }

    &--space-between {
      min-height: 100%;
      padding: 100px 0 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;

      @include media-up(md) {
        padding: 110px 0;

        @media (max-height: 600px) {
          padding: 60px 0;
        }
      }

      @include media-up(xl) {
        padding: 160px 0;

        @media (max-height: 700px) {
          padding: 60px 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/StepWrapper.vue